var AuthHeaders;
(function (AuthHeaders) {
    AuthHeaders["Authorization"] = "authorization";
    AuthHeaders["Bearer"] = "Bearer";
})(AuthHeaders || (AuthHeaders = {}));

export { AuthHeaders };
